import { render, staticRenderFns } from "./VProductLogbook.vue?vue&type=template&id=24a1d11a"
import script from "./VProductLogbook.vue?vue&type=script&lang=js"
export * from "./VProductLogbook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports